import { sendParent } from 'xstate';

import { type CustomizationMachineAction, type ParentEvent } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Tells the parent the product could not be added to the bag.
 */
export const reportFailedToAddToBag: CustomizationMachineAction = sendParent(
  (args): ParentEvent => ({ type: 'customization.failed-to-add-to-bag', actorId: args.self.id }),
);
